import {
    CLOSED_STATUS,
    HIATUS_STATUS,
    OPEN_STATUS,
    WAITLIST_STATUS,
} from '../../../constants/StatusToolTipConstants';
import styles from './StatusToolTip.module.scss';

const StatusToolTip = () => {
    return (
        <div className={styles.statusTooltipContent}>
            <ul className={styles.ul}>
                <li className={styles.li}>
                    <span className={styles.span}>{OPEN_STATUS}</span> - Actively accepting
                    applications.
                </li>
                <li className={styles.li}>
                    <span className={styles.span}>{HIATUS_STATUS}</span> - Applications are being
                    accepted, but not processed. Processing will resume at some point in the future.
                </li>
                <li className={styles.li}>
                    <span className={styles.span}>{WAITLIST_STATUS}</span> - Not currently accepting
                    new applications, but are expected to resume upon additional funding.
                </li>
                <li className={styles.li}>
                    <span className={styles.span}>{CLOSED_STATUS}</span> - No longer accepting new
                    applications. Not expected to receive additional funding.
                </li>
            </ul>
            <p style={{ marginTop: '10px' }}>For reference purposes only.</p>
        </div>
    );
};

export default StatusToolTip;
